export default __webpack_public_path__ + "static/packShotPE-588a9396554d3c4e8df27b20206fba5a.png";